export default __webpack_public_path__ + "static/media/2_0092.5d4242aa.webp";